import {gql, useQuery} from '@apollo/client';

const GET_DEFAULT_TRENDS = gql`
  query GetDefaultTrends($sport: String!) {
      defaultTrends(sport: $sport) {
        atsLosses
        atsWins
        id
        isAtsTrend
        isOuTrend
        isSuTrend
        losses
        oPoints
        overs
        points
        trend
        trendDescription
        unders
        wins
      }
  }
`;

export const useGetDefaultTrends = (
    sport: string = 'nba',
    skip: boolean = false,
) => useQuery(GET_DEFAULT_TRENDS, {
    variables: {sport},
    skip,
})